import { apiDelete, apiGet, apiPost, apiPut, extractErrorMessage } from "../client";

export async function fetchAdminStudents({ search = "", by = "username" } = {}) {
  const params = new URLSearchParams();
  if (String(search || "").trim()) params.set("search", String(search).trim());
  if (String(by || "").trim()) params.set("by", String(by).trim());
  const query = params.toString() ? `?${params.toString()}` : "";
  return apiGet(`/admin/students${query}`);
}

export async function createAdminStudent(data) {
  return apiPost("/admin/students", data);
}

export async function fetchAdminStudentOverview(studentId) {
  return apiGet(`/admin/student-profile/${studentId}/overview`);
}

export async function fetchAdminStudentProfile(studentId) {
  const json = await apiGet(`/admin/student-profile/${studentId}`);
  return json.student;
}

export async function updateAdminStudentProfile(studentId, data) {
  const json = await apiPut(`/admin/student-profile/${studentId}`, data);
  if (!json?.ok) {
    throw new Error(extractErrorMessage(json, "تعذر تحديث بيانات الطالب"));
  }
  return json.student;
}

export async function resetAdminStudentPassword(studentId, newPassword) {
  const json = await apiPut(`/admin/student-profile/${studentId}/reset-password`, {
    newPassword,
  });

  if (!json?.ok) {
    throw new Error(extractErrorMessage(json, "تعذر إعادة تعيين كلمة المرور"));
  }

  return json;
}

export async function deleteAdminStudent(userId) {
  return apiDelete(`/admin/students/${userId}`);
}

export async function deleteAdminStudentsBulk(studentIds = []) {
  return apiPost("/admin/students/bulk-delete", {
    student_ids: Array.isArray(studentIds) ? studentIds : [],
  });
}

export async function activateAdminStudent(userId) {
  return apiPut(`/admin/activation/students/${userId}/activate`);
}

export async function suspendAdminStudent(userId) {
  return apiPut(`/admin/activation/students/${userId}/suspend`);
}

export async function reactivateAdminStudent(userId) {
  return apiPut(`/admin/activation/students/${userId}/reactivate`);
}

export async function activateAdminStudentsBulk(studentIds = []) {
  return apiPut("/admin/activation/students/bulk/activate", {
    student_ids: Array.isArray(studentIds) ? studentIds : [],
  });
}

export async function suspendAdminStudentsBulk(studentIds = []) {
  return apiPut("/admin/activation/students/bulk/suspend", {
    student_ids: Array.isArray(studentIds) ? studentIds : [],
  });
}

export async function reactivateAdminStudentsBulk(studentIds = []) {
  return apiPut("/admin/activation/students/bulk/reactivate", {
    student_ids: Array.isArray(studentIds) ? studentIds : [],
  });
}
